import colors from '../../themes/colors';

export default {
  headerWide: {
    // backgroundColor: colors.primary1Color,
    flex: '0 0 306px',
    marginLeft: -18,
    justifyContent: `flex-start`
  },
  accountWide: {
    flexWidth: '275px'
  },
  toolbar: {
    padding: '0 18px',
    backgroundColor: colors.darkGrey,
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    boxShadow:
      'rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px',
    zIndex: 100
  },
  accountLabel: {
    color: '#fff',
    display: 'inline-block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: 190,
    paddingLeft: 8
  },
  breadcrumbGroup: {
    paddingLeft: 16,
    marginRight: 'auto'
  },
  breadcrumb: {
    display: 'flex',
    alignItems: 'center'
  },
  breadcrumbDisplay: {
    display: 'inline-block'
  },
  breadcrumbContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  breadcrumbSeparator: {
    color: 'rgb(153, 153, 153)'
  },
  labelStyle: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: 200,
    display: 'inline-block'
  },
  button: {
    color: '#999999'
  },
  isLastButton: {
    color: 'rgb(78, 163, 216)'
  },
  overflowHidden: {
    overflow: 'hidden'
  },
  scrollAccountList: {
    maxHeight: '520px',
    overflowY: 'auto'
  }
};



// WEBPACK FOOTER //
// ./src/containers/NavBar/style.js